const PERMISSION_KEY= "core:permission";
const PAGE_URL = {
    PERMISSION_PAGE: "/admin/core/permission"
}

export {PERMISSION_KEY, PAGE_URL}

